import React, { useEffect, useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import { useDataContext } from '../context/DataContext';
import { useParams } from 'react-router-dom';


const AccordionItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  return (
    <div className={`accordion-item ${isOpen ? 'accordianactive' : ''}`}>
      <div className="accordion-header" onClick={toggleAccordion}>
        {title}
        <span className={`accordion-arrow ${isOpen ? 'rotate' : ''}`}>&#9654;</span>
      </div>
      <div className="accordion-content">
        {isOpen && <div>{children}</div>}
      </div>
    </div>
  );
};
const BlogInside = () => {


    const { fetchBlogByUrl, blog } = useDataContext();

    const { url_title } = useParams()

    useEffect(() => {
        fetchBlogByUrl(url_title)

        AOS.init({
            duration: 600, // Animation duration
            easing: "ease-in-sine", // Animation easing
        });
    }, [url_title]);


    useEffect(() => {
    const headers = document.querySelectorAll(".accordion-header");

    headers.forEach(header => {
      const toggleAccordion = () => {
        const item = header.closest(".accordion-item");
        item.classList.toggle("accordianactive");
      };
      header.addEventListener("click", toggleAccordion);

      // Clean up
      return () => header.removeEventListener("click", toggleAccordion);
    });
  }, [blog]);


    return (
        <main id="blog-inside">
            {console.log(blog)}
            <div className="container">
                <div className="row flex-column-reverse flex-lg-row">
                    <div className="col-lg-12">
                        <h1 className='my-4'>{blog.title}</h1>
                        <div className="blog-banner mb-4">
                            <img src={blog.featured_image} alt="blog-banner" />
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: blog.description }} />
                    </div>
                    {/* <div className="col-lg-4">
                        <div className="table-Contents">
                            <h3 className="mb-3">Table Of Contents</h3>

                            <div dangerouslySetInnerHTML={{ __html: blog.table_content }} />

                        </div>
                    </div> */}
                </div>
            </div>

        </main>
    )
}

export default BlogInside